import { createTheme } from '@mui/material/styles';
import './ThemeTypes';

const IbattmanTheme = createTheme({
    palette: {
        common: {
            black: "#272727"
        },
        primary: {
            main: "#5893be",
            light: "#8bb5d3",
            dark: "#426d8e"
        },
        secondary: {
            main: "#76bd75",
            light: "#a2db9e",
            dark: "#4b8e50"
        },
        surface: {
            main: "#ffffffff",
        }
    },
});

export default IbattmanTheme;
